import type { FeatureMiddleware } from '@cast/api-client';
import { demoClusterPricingNodes } from '@cast/fixtures';

import { handleOpDemoInterceptor } from '../utils';

export const pricing: FeatureMiddleware<'pricing'> = {
  getClusterNodesPricing: async (args) =>
    handleOpDemoInterceptor({
      ...args,
      opDemoFallback: { nodes: [] },
      demoFixtureLoader: demoClusterPricingNodes,
    }),
};
